import * as React from 'react';

import type { W_JobMaterial_SyncDiff_VM_Single } from 'ab-api/web/jobMaterial/syncDiff';

import MaterialEntryChange from './MaterialEntryChange';
import styles from './styles.module.scss';

interface OwnProps {
	materialsForImport: W_JobMaterial_SyncDiff_VM_Single[];
	materialsForRemove: W_JobMaterial_SyncDiff_VM_Single[];
	onDelete: (material: W_JobMaterial_SyncDiff_VM_Single) => void;
}

type Props = OwnProps;

const SyncDiff: React.FC<Props> = (props) => {
	const { materialsForImport, materialsForRemove, onDelete } = props;

	const renderImportedMaterial = React.useCallback((material: W_JobMaterial_SyncDiff_VM_Single) => {
		return (
			<MaterialEntryChange
				added={true}
				className={styles.materialEntry}
				key={material.id}
				material={material}
				onDelete={onDelete}
			/>
		);
	}, [onDelete]);

	const renderRemovedMaterial = React.useCallback((material: W_JobMaterial_SyncDiff_VM_Single) => {
		return (
			<MaterialEntryChange
				className={styles.materialEntry}
				key={material.id}
				material={material}
				onDelete={onDelete}
				removed={true}
			/>
		);
	}, [onDelete]);

	return (
		<div className={styles.SyncDiff}>
			<div className={styles.diffColumn}>
				<div className={styles.title}>Import</div>
				{
					!!materialsForImport.length
						? (
							<div className={styles.list}>{materialsForImport.map(renderImportedMaterial)}</div>
						) : (
							<div className={styles.listEmpty}>
								<div className={styles.emptyDescription}>No Materials to import.</div>
							</div>
						)
				}
				<div className={styles.counter}>Imported Materials: {materialsForImport.length}</div>
			</div>
			<div className={styles.diffColumn}>
				<div className={styles.title}>Remove</div>
				{
					!!materialsForRemove.length
						? (
							<div className={styles.list}>{materialsForRemove.map(renderRemovedMaterial)}</div>
						) : (
							<div className={styles.listEmpty}>
								<div className={styles.emptyDescription}>No Materials to remove.</div>
							</div>
						)
				}
				<div className={styles.counter}>Removed Materials: {materialsForRemove.length}</div>
			</div>
		</div>
	);
};

export default React.memo(SyncDiff);
